import React from 'react'
const TIDAL = 'tidal'
export const partners: {
  tidal: {
    description: React.ReactNode
    title: string
  }
} = {
  [TIDAL]: {
    title: 'Data sharing with TIDAL',
    description: (
      <>
        We are pleased to welcome TIDAL artists to DISCO! By signing up to use
        our services, you direct DISCO to inform TIDAL that you have joined our
        platform and to share certain information with TIDAL. This information
        may include your name and email address, as well as statistics about
        your music and other files – including your most streamed tracks and
        videos, most accessed and downloaded playlists, and total play counts.
        For more information about how we use and share your information in
        other ways, please review our{' '}
        <a
          href="https://www.disco.ac/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-link"
        >
          privacy policy.
        </a>
      </>
    ),
  },
}
